export default __webpack_public_path__ + "static/media/logo.f282b236.svg";